// KORIO site content (migrated from OneTec, rebranded)

export const CONTACT = {
  email: "hello@korio.eu",
  phone: "+32 2 702 36 36",
  phoneHref: "tel:+3227023636",
  company: "KORIO SRL",
  address: ["Tollaan 75", "1932 Sint-Stevens-Woluwe", "Belgium"],
  vat: "VAT BE0478.889.493",
};

export const STATS = [
  { value: 12, suffix: "", label: "Specialists" },
  { value: 415, suffix: "", label: "Events / year" },
  { value: 42, suffix: "", label: "Countries" },
  { value: 250, suffix: "+", label: "Clients" },
];

export const CLIENTS = [
  "Amazon", "Nike", "Samsung", "Coca-Cola", "PepsiCo",
  "Philips", "Nissan", "RTL", "Triumph",
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Advice",
    body: "We listen first. Every event brief is unique — we tailor the tech, not the other way around.",
  },
  {
    n: "02",
    title: "Confidence",
    body: "12 specialists, 42 countries, 415 events a year. We've seen the edge cases. We've fixed them.",
  },
  {
    n: "03",
    title: "Best Solution",
    body: "We benchmark, prototype, and over-deliver. Nothing leaves our warehouse untested.",
  },
];

export const SERVICES = [
  {
    id: "brand-activation",
    index: "01 / 03",
    title: "Brand Activation",
    tagline: "Make strangers into fans.",
    summary: "Photo/Video activations, interactive games, live personalisation, AI, AR & VR.",
    image: "https://images.unsplash.com/photo-1488554378835-f7acf46e6c98?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    points: [
      "Photo & video experiences — from the iconic Vespa booth to 120° bullet-time rigs",
      "AI face swap & generative content moments",
      "Live personalisation (t-shirts, tote bags, merch) using transfer presses",
      "AR / VR branded experiences — shareable, measurable, unforgettable",
      "Interactive games and mosaic reveals",
    ],
    category: "EXPERIENCE CORE",
  },
  {
    id: "event-technology",
    index: "02 / 03",
    title: "Event Technology",
    tagline: "The invisible backbone of flawless events.",
    summary: "Event registration, on-site services, access control, tracking technology.",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    points: [
      "Branded online registration flows with payments and automated communications",
      "On-site check-in, QR scanning, RFID, and award-winning badge printing",
      "Access control with multi-zone logic and live attendance dashboards",
      "Mobile voting, polls and Q&A that drive stage interaction",
      "Lead-tracking tools for exhibitors that turn conversations into pipeline",
    ],
    category: "EVENT CORE",
  },
  {
    id: "it-av-rental",
    index: "03 / 03",
    title: "IT & AV Rental",
    tagline: "Everything that plugs in, delivered.",
    summary: "Laptops, screens, printers, TV's, LED walls — delivered and installed.",
    image: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    points: [
      "Pre-configured laptops, tablets and printers for workshops, training rooms, pop-ups",
      "4K screens, touch displays, and LED walls — with install and breakdown",
      "Full AV: sound systems, projectors, microphones, stage kits",
      "Pan-European delivery with on-site engineers",
      "Insured inventory and 24/7 hotline during events",
    ],
    category: "TECH CORE",
  },
];

export const CATEGORIES = ["All", "Event Technology", "Brand Activation", "IT & AV Rental"];

const F = "https://onetec.eu/api/files/onetec/uploads";

export const PRODUCTS = [
  { name: "Access Control", category: "EVENT CORE", desc: "Seamless secure entry for any event size.", image: `${F}/81eaa177-2505-4db4-82ce-f11d4d64ddf8.jpg` },
  { name: "Online Registration", category: "EVENT CORE", desc: "Branded registration journeys that convert.", image: `${F}/62c9c15f-5eae-4e7a-9e2b-1654d690f12d.jpg` },
  { name: "Onsite Registration & Badging", category: "EVENT CORE", desc: "Zero-queue badging, printed in seconds.", image: `${F}/17b897eb-7987-4731-b1e3-24e80508de74.jpg` },
  { name: "Webinars", category: "EVENT CORE", desc: "Premium virtual events with live interaction.", image: `${F}/617015ea-fc17-4378-a095-234b8027a2a0.jpg` },
  { name: "Lead Trackers", category: "EVENT CORE", desc: "Capture every opportunity on the show floor.", image: `${F}/e43fabad-5b8c-4c34-ba81-5d9d440c6411.jpg` },
  { name: "Mobile Voting System", category: "EVENT CORE", desc: "Engage every attendee's voice in real time.", image: `${F}/270f906b-5182-42ef-8342-fb65d59c5da5.jpg` },
  { name: "The Smart Info Hub", category: "EVENT CORE", desc: "Instant access. Zero paper.", image: `${F}/25994e90-0073-42e3-8766-52652552ed1b.jpg` },
  { name: "Custom Transfer Press", category: "EXPERIENCE CORE", desc: "Personalise merch live, in front of the crowd.", image: `${F}/a59ac110-398d-43b2-88a7-33125d29b4b2.jpg` },
  { name: "The Virtual Experience (VR)", category: "EXPERIENCE CORE", desc: "Immersive VR journeys branded for your audience.", image: `${F}/666e7e49-03dc-4169-a323-957bbd8ea83d.jpg` },
  { name: "The Face Swap (AI)", category: "EXPERIENCE CORE", desc: "AI places your guest in iconic moments.", image: `${F}/d459595a-fff5-43b7-8fe4-1973b4265fcf.jpg` },
  { name: "The Light Painting Experience", category: "EXPERIENCE CORE", desc: "Paint with light, freeze the magic.", image: `${F}/e895baf5-bd36-410a-b2bb-b9d71ed4aa9f.jpg` },
  { name: "The Mosaic Photo Experience", category: "EXPERIENCE CORE", desc: "A giant brand mural built from guest selfies.", image: `${F}/6290f528-8573-4e7f-aea8-47d968580db5.jpg` },
  { name: "The Incredible Vespa", category: "EXPERIENCE CORE", desc: "A vintage Vespa turned into a mobile photobooth.", image: `${F}/f3781f86-e563-4b8d-b9dd-78754b9e4981.jpg` },
  { name: "The Amsterdammer", category: "EXPERIENCE CORE", desc: "Dutch cargo bike meets branded photo station.", image: `${F}/7b5f90a8-a179-4125-aead-de4bdbe9a328.jpg` },
  { name: "The 120° Experience", category: "EXPERIENCE CORE", desc: "Bullet-time 120° camera rig, Matrix-style.", image: `${F}/be78fb33-a4fd-4b11-975b-d41e3d7aaef8.jpg` },
  { name: "Studio from the Sky", category: "EXPERIENCE CORE", desc: "Overhead photo studio — gravity optional.", image: `${F}/f7afaa02-2bc4-4567-bf67-d05dc5bffe10.jpg` },
  { name: "Studio Upside Down", category: "EXPERIENCE CORE", desc: "A room rotated 180°. Minds blown.", image: `${F}/3d91a984-20d1-4632-bc81-e84731a13c23.jpg` },
  { name: "Super Selfie", category: "EXPERIENCE CORE", desc: "From selfie to spectacular panorama.", image: `${F}/ec7af76a-df3d-4875-90c1-1b831dfd4eec.jpg` },
  { name: "The Active Experience", category: "EXPERIENCE CORE", desc: "Turn energy into excitement.", image: `${F}/c5d0c89a-8e99-47d4-9e8a-26ca82594a10.jpg` },
  { name: "Laptop Rental", category: "TECH CORE", desc: "Configured, insured, delivered, supported.", image: `${F}/2f7d3846-c656-4e72-91b2-65cf0fe9bbfb.jpg` },
  { name: "Screens & AV Rental", category: "TECH CORE", desc: "From 4K panels to LED walls, delivered & installed.", image: `${F}/e3c1ede6-1711-4f96-ac89-c1151a034773.jpg` },
];

export const TEAM = [
  { name: "Team Member", role: "Founder & Managing Director", bio: "Sets the vision and keeps KORIO at the core of every client relationship." },
  { name: "Team Member", role: "Head of Event Technology", bio: "Leads registration, badging and access-control systems from brief to show floor." },
  { name: "Team Member", role: "Brand Activation Lead", bio: "Turns ideas into shareable, unforgettable live experiences." },
  { name: "Team Member", role: "Operations Manager", bio: "Orchestrates logistics across 42 countries so nothing is left to chance." },
  { name: "Team Member", role: "Lead AV Engineer", bio: "Makes sure every screen, LED wall and sound system runs flawlessly." },
  { name: "Team Member", role: "Client Success Manager", bio: "Your single point of contact — before, during and after the event." },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1670028514318-0ac718c0590d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";
